<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.strata_id}">
      <label>Select Strata:</label>
      <select :value="strata_id" name="strata_id" class="form-control" @change="handleChange">
        <option value="" />
        <option v-for="strata in config.strata" :value="strata.id">
          {{ strata.name }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      id: String,
      strata_id: Number
    },
    methods: {
      validate: function() {
        this.errors = {};
        if (!this.isNumber(this.strata_id)) {
          this.errors.strata_id = "Please select a Strata.";
        }
        
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
